// src/pages/contact/ContactPage.jsx
import React, { useState, useEffect } from 'react';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import { sendContactMessage } from '../../services/api';
import './ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [settings, setSettings] = useState({
    contact_hero_title: 'Contact Us',
    contact_hero_subtitle: 'We\'d love to hear from you! Get in touch with us.',
    contact_email_title: 'Email Us',
    contact_email_1: 'support@shopdemo.com',
    contact_email_2: 'sales@shopdemo.com',
    contact_phone_title: 'Call Us',
    contact_phone_1: '+1 (555) 123-4567',
    contact_phone_2: '+1 (555) 987-6543',
    contact_address_title: 'Visit Us',
    contact_address_1: '123 Demo Street',
    contact_address_2: 'New York, NY 10001',
    contact_hours_title: 'Business Hours',
    contact_hours_1: 'Mon-Fri: 9am - 6pm',
    contact_hours_2: 'Sat: 10am - 4pm',
    contact_form_title: 'Send us a message',
    contact_form_success_message: 'Thank you for your message! We\'ll get back to you soon.',
    contact_map_embed_url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.2219901290355!2d-74.00369368400567!3d40.71312937933085!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a316bb6a1c5%3A0xb89d1fe6bc499443!2sDowntown%20Conference%20Center!5e0!3m2!1sen!2sus!4v1641234567890!5m2!1sen!2sus'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await fetch('https://demo-site.storii.com.pk/demo-api/public/get-settings.php');
      const data = await response.json();
      if (data.success && data.settings) {
        setSettings(prev => ({ ...prev, ...data.settings }));
      }
    } catch (error) {
      console.error('Error loading settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await sendContactMessage(formData);
      setSubmitted(true);
      setFormData({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => setSubmitted(false), 5000);
    } catch (error) {
      console.error('Error sending message:', error);
      alert('Failed to send message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="contact-page">
      <div className="contact-header">
        <h1>{settings.contact_hero_title}</h1>
        <p>{settings.contact_hero_subtitle}</p>
      </div>

      <div className="contact-content">
        <div className="contact-info-grid">
          <div className="contact-card">
            <FaEnvelope className="contact-icon" />
            <h3>{settings.contact_email_title}</h3>
            <p>{settings.contact_email_1}</p>
            <p>{settings.contact_email_2}</p>
          </div>

          <div className="contact-card">
            <FaPhone className="contact-icon" />
            <h3>{settings.contact_phone_title}</h3>
            <p>{settings.contact_phone_1}</p>
            <p>{settings.contact_phone_2}</p>
          </div>

          <div className="contact-card">
            <FaMapMarkerAlt className="contact-icon" />
            <h3>{settings.contact_address_title}</h3>
            <p>{settings.contact_address_1}</p>
            <p>{settings.contact_address_2}</p>
          </div>

          <div className="contact-card">
            <FaClock className="contact-icon" />
            <h3>{settings.contact_hours_title}</h3>
            <p>{settings.contact_hours_1}</p>
            <p>{settings.contact_hours_2}</p>
          </div>
        </div>

        <div className="contact-form-container">
          <h2>{settings.contact_form_title}</h2>
          {submitted && (
            <div className="success-message">
              {settings.contact_form_success_message}
            </div>
          )}

          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Your Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                name="message"
                rows="6"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button type="submit" className="submit-contact-btn" disabled={submitting}>
              {submitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>

        <div className="map-container">
          <iframe
            title="map"
            src={settings.contact_map_embed_url}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;